/**
 * PIPELINE SLICE — stato del funnel commerciale core.
 */

import { createSlice } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { pipelineThunks } from './pipelineThunks';
import type { PipelineSliceState } from './pipelineTypes';

const initialState: PipelineSliceState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  totalCount: 0,
};

export const pipelineSlice = createSlice({
  name: 'pipelines',
  initialState,
  reducers: {
    clearCurrentPipeline(state) {
      state.currentItem = null;
    },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, pipelineThunks, (p) => p.pipelineId);
  },
});

export const { clearCurrentPipeline } = pipelineSlice.actions;
export const pipelineReducer = pipelineSlice.reducer;
